export default function parseTime(timeStr: string): string {
  return timeStr.replace("T", " ").slice(0, 19);
}